import { WorkoutFilters } from '../models/workout-filters';
import { partitionWorkoutFilters } from './partition-workout-filters';

export function matchesWorkoutFilters(
  consoleWorkoutFilters: WorkoutFilters,
  workoutWorkoutFilters: WorkoutFilters,
): boolean {
  const { allowed, excluded, required } = partitionWorkoutFilters(
    consoleWorkoutFilters,
  );
  const against = !workoutWorkoutFilters
    ? []
    : typeof workoutWorkoutFilters === 'string'
      ? [workoutWorkoutFilters]
      : workoutWorkoutFilters;

  const isAllowed = !allowed.length || allowed.some(i => against.includes(i));
  const isNone = !excluded.length || !excluded.some(n => against.includes(n));
  const isAll = !required.length || required.every(a => against.includes(a));

  return isAllowed && isNone && isAll;
}
